import { render, staticRenderFns } from "./EvaluacionDesempeñoAcademico.vue?vue&type=template&id=129bb1a6&scoped=true"
import script from "./EvaluacionDesempeñoAcademico.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempeñoAcademico.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionDesempeñoAcademico.vue?vue&type=style&index=0&id=129bb1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129bb1a6",
  null
  
)

export default component.exports